export const DEFAULT_STATUS_MESSAGE = "Guideline Planning data refreshes every few minutes. If recent changes aren't visible, please re-run report using the report’s reload button.";
